import React from "react";
import ComparisonBarChart from "@/charts/ComparisonBarChart";

const ComparisonBarAdapter = ({ spec, containerRef }) => {
  const { config = {}, data = [], title } = spec;
  const firstRow = data[0] || {};
  const rowKeys = Object.keys(firstRow);

  const labelKey =
    config.labelKey ||
    ["brand", "entity", "name", "label", "category"].find((k) => k in firstRow) ||
    rowKeys.find((k) => typeof firstRow[k] === "string") ||
    rowKeys[0] ||
    "brand";

  const numericKeys = rowKeys.filter(
    (k) => k !== labelKey && typeof firstRow[k] === "number"
  );

  const valueAKey =
    config.valueAKey ||
    ["period_a", "prior", "value_a", "a", "previous"].find((k) => k in firstRow) ||
    numericKeys[0] ||
    rowKeys.filter((k) => k !== labelKey)[0] ||
    "period_a";

  const valueBKey =
    config.valueBKey ||
    ["period_b", "current", "value_b", "b", "latest"].find((k) => k in firstRow) ||
    numericKeys[1] ||
    rowKeys.filter((k) => k !== labelKey && k !== valueAKey)[0] ||
    "period_b";

  const seriesALabel = config.seriesALabel || "Period A";
  const seriesBLabel = config.seriesBLabel || "Period B";

  return (
    <div ref={containerRef} className="assistant-chart-render-wrapper comparison-bar-render-wrapper">
      <ComparisonBarChart
        data={data}
        labelKey={labelKey}
        valueAKey={valueAKey}
        valueBKey={valueBKey}
        seriesALabel={seriesALabel}
        seriesBLabel={seriesBLabel}
        title={title}
        isLoaded={true}
        maxItems={config.maxItems || 10}
      />
    </div>
  );
};

export default ComparisonBarAdapter;
